<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><span><i>For Tab Andrews</i></span></p>
<p class="center"><span><i>(alias Peter Gethers),</i></span></p>
<p class="center"><span><i>the best partner a boy</i></span></p>
<p class="center"><span><i>named Biff could ever ask for</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3dedication.vue?58ab52c8